module.exports = __webpack_public_path__ + "static/media/volcano.aca9855c.jpeg";